<div class="agpr-external-data-source-date-range-field">
  <div
    *ngIf="field.label"
    [id]="id + '_label'"
    class="agpr-external-data-source-date-range-field-heading"
  >
    {{ field.label | localize }}
  </div>
  <div role="radiogroup" [attr.aria-labelledby]="id + '_label'">
    <div class="agpr-external-data-source-date-range-field-radioContainer">
      <agpr-radio
        [id]="id + 'externalDataSourceDateRangeField.custom'"
        label="Reports.externalDataSource.dateRange.custom"
        hiddenLabel="Reports.externalDataSource.dateRange.custom"
        [value]="dateInputTypesEnum.custom"
        name="dateInputType"
        [(ngModel)]="selectedDateInputType"
        (ngModelChange)="handleDateInputTypeChange($event)"
      ></agpr-radio>
    </div>
    <div class="agpr-external-data-source-date-range-field-radioContainer">
      <agpr-radio
        [id]="id + 'externalDataSourceDateRangeField.dailyMonthly'"
        label="Reports.externalDataSource.dateRange.dailyMontly"
        hiddenLabel="Reports.externalDataSource.dateRange.dailyMontly"
        [value]="dateInputTypesEnum.useValue"
        name="dateInputType"
        [(ngModel)]="selectedDateInputType"
        (ngModelChange)="handleDateInputTypeChange($event)"
      ></agpr-radio>
    </div>

    <div
      *ngIf="selectedDateInputType === dateInputTypesEnum.useValue"
      class="agpr-external-data-source-date-range-field-indent"
      role="radiogroup"
    >
      <div class="agpr-external-data-source-date-range-field-radioContainer">
        <agpr-radio
          [id]="id + 'externalDataSourceDateRangeField.dailyRelative'"
          label="Reports.externalDataSource.dateRange.dailyRelative"
          hiddenLabel="Reports.externalDataSource.dateRange.dailyRelative"
          [value]="timePeriodEnum.daily"
          name="relativeDateRangePresetType"
          [(ngModel)]="selectedTimePeriod"
          (ngModelChange)="handleTimePeriodChange($event)"
        ></agpr-radio>
      </div>
      <div class="agpr-external-data-source-date-range-field-radioContainer">
        <agpr-radio
          [id]="id + 'externalDataSourceDateRangeField.monthlyRelative'"
          label="Reports.externalDataSource.dateRange.monthlyRelative"
          hiddenLabel="Reports.externalDataSource.dateRange.monthlyRelative"
          [value]="timePeriodEnum.monthly"
          name="relativeDateRangePresetType"
          [(ngModel)]="selectedTimePeriod"
          (ngModelChange)="handleTimePeriodChange($event)"
        ></agpr-radio>
      </div>
    </div>
    <agpr-date-query-popup
      [id]="id + '_externalDataSourceDateRangeField_dateQueryPopup'"
      class="agpr-external-data-source-date-range-field-picker"
      [options]="dateRangeOptions"
      [hideDateTypeSelection]="true"
      [(ngModel)]="dateRange"
      (ngModelChange)="handleDateRangeChange()"
  ></agpr-date-query-popup>
  </div>
</div>
